var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPipelinesort(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 10,
    viewBox: "0 0 9 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.20082 8.39953C3.14826 8.30605 3.04899 8.24763 2.9438 8.24763H2.65179V3.29209C2.65179 3.12847 2.52331 3 2.3597 3H1.7756C1.61206 3 1.48352 3.12847 1.48352 3.29209V8.24763H1.1915C1.08638 8.24763 0.987044 8.30605 0.934484 8.39953C0.881923 8.4988 0.887704 8.60977 0.946198 8.70326L1.82238 9.87145C1.88072 9.95322 1.96835 10 2.06769 10C2.16695 10 2.25458 9.95322 2.313 9.87145L3.18918 8.70326C3.2476 8.60977 3.25345 8.4988 3.20082 8.39953Z",
    fill: "#FF641A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.18985 8.70326L2.31367 9.87145C2.25525 9.95322 2.16762 10 2.06836 10V3H2.36045C2.52398 3 2.65246 3.12847 2.65246 3.29209V8.24763H2.94454C3.04966 8.24763 3.14893 8.30605 3.20156 8.39953C3.25412 8.4988 3.24827 8.60977 3.18985 8.70326Z",
    fill: "#F03800"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.89844 0V1.81818H6.53569L6.75546 0.681818L6.53569 0H3.89844Z",
    fill: "#FFDF40"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.04102 0H8.89804V1.81818H6.04102V0Z",
    fill: "#FFBE40"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.89844 2.72705V4.54523H6.53569L6.75546 3.40887L6.53569 2.72705H3.89844Z",
    fill: "#FFDF40"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3.89844 5.45459V7.27277H6.53569L6.75546 6.13641L6.53569 5.45459H3.89844Z",
    fill: "#FFDF40"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M6.04102 2.72705H8.89804V4.54523H6.04102V2.72705Z",
    fill: "#FFBE40"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M6.04102 5.45459H8.89804V7.27277H6.04102V5.45459Z",
    fill: "#FFBE40"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPipelinesort);
export default __webpack_public_path__ + "static/media/pipelinesort.4a1b458bc021fbc7c3e64cdaac8bffdc.svg";
export { ForwardRef as ReactComponent };